import React from 'react';
import { Button } from '../../button/Button';
import './NextAndBackButtons.css';

export const NextAndBackButtons = ({ onBack, onNext }) => {
  return (
    <div className="btn-container">
      <button className="btn btn-secondary" onClick={onBack}>Wróć</button>
      <button className="btn btn-primary" onClick={onNext}>Dalej</button>
    </div>
  );
};